import React, { useState } from 'react';
import { Bell, Home, BarChart2, Map, Menu, X, FileText, Database } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ onMenuClick }) => {
    const location = useLocation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const isActive = (path) => location.pathname === path;
    const isLanding = location.pathname === '/';

    const navLinks = [
        { path: '/app', label: 'Dashboard', icon: BarChart2 },
        { path: '/iztacalco', label: 'Datos', icon: Map },
        { path: '/blog', label: 'Blog', icon: FileText },
        { path: '/vibe-coding', label: 'Bootcamp', icon: Database },
    ];

    return (
        <header className="h-16 border-b border-zinc-800 bg-background/50 backdrop-blur-sm flex items-center justify-between px-4 md:px-8 sticky top-0 z-50">
            <div className="flex items-center gap-4">
                {/* Brand */}
                <Link to="/" className="flex items-center gap-2 text-white font-display font-bold">
                    <span className="text-primary text-xl">i³</span>
                    <span className="hidden sm:inline text-sm">Instituto de Innovación Iztacalco</span>
                </Link>

                {/* Navigation Tabs - Desktop */}
                <nav className="hidden md:flex items-center gap-1 ml-4">
                    {navLinks.map(({ path, label, icon: Icon }) => (
                        <Link
                            key={path}
                            to={path}
                            className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-mono transition-all ${isActive(path)
                                ? 'bg-primary/20 text-primary border border-primary/30'
                                : 'text-zinc-400 hover:text-white hover:bg-zinc-800'
                                }`}
                        >
                            <Icon size={14} />
                            <span>{label}</span>
                        </Link>
                    ))}
                </nav>
            </div>

            <div className="flex items-center gap-4">
                {/* Home Link */}
                <Link
                    to="/"
                    className={`hidden md:flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-mono transition-all ${isLanding
                        ? 'bg-primary/20 text-primary border border-primary/30'
                        : 'text-zinc-400 hover:text-white hover:bg-zinc-800'
                        }`}
                >
                    <Home size={14} />
                    <span>Inicio</span>
                </Link>

                {/* Mobile Menu Button */}
                <button
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    className="md:hidden text-zinc-400 hover:text-white p-2"
                >
                    {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <div className="absolute top-16 left-0 right-0 bg-background border-b border-zinc-800 p-4 md:hidden z-50">
                    <nav className="flex flex-col gap-2">
                        <Link
                            to="/"
                            onClick={() => setMobileMenuOpen(false)}
                            className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-mono ${isLanding ? 'bg-primary/20 text-primary' : 'text-zinc-400'
                                }`}
                        >
                            <Home size={18} />
                            Inicio
                        </Link>
                        {navLinks.map(({ path, label, icon: Icon }) => (
                            <Link
                                key={path}
                                to={path}
                                onClick={() => setMobileMenuOpen(false)}
                                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-mono ${isActive(path) ? 'bg-primary/20 text-primary' : 'text-zinc-400'
                                    }`}
                            >
                                <Icon size={18} />
                                {label}
                            </Link>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
};

export default Header;
